import type { VisibilityTypeId } from '#types/System.types';

type Params = {
  visibilityMode?: VisibilityTypeId;
  visibilityTypes?: VisibilityTypeId[];
};

export const isVisibleInVisibilityMode = ({ visibilityMode, visibilityTypes }: Params): boolean => {
  if (visibilityMode === undefined || visibilityMode === 'internal') return true;

  if (!visibilityTypes || visibilityTypes.length === 0) return true;

  return visibilityTypes.includes(visibilityMode);
};

